import { z } from "zod";
import { OTP_CONFIG } from "@/consts/otp.consts";

export const createEmailSchema = (t: (key: string) => string) =>
  z.object({
    email: z
      .string()
      .min(1, t("errors.required"))
      .trim()
      .toLowerCase()
      .email({ message: t("errors.invalidEmail") }),
  });

export const createOtpSchema = (t: (key: string) => string) =>
  z.object({
    otp: z
      .string()
      .trim()      
      .length(OTP_CONFIG.LENGTH, t("verification.otpMinLength")),
  });

